module.exports = __webpack_public_path__ + "static/media/miembros-individuales-mini.2811ab1c.jpg";